import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { LoadingButton } from "../../components/LoadingButton";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface BaseOrientationRequiredCardProps {
  isLoading: boolean;
  buttonText: string;
  onClick: () => void;
}

export function BaseOrientationRequiredCard(props: BaseOrientationRequiredCardProps) {
  const { isLoading, buttonText, onClick } = props;
  const { shiftId } = useShiftModalsDataContext();
  const { userId: workerId } = useDefinedWorker();

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_ORIENTATION_REQUIRED_CARD, {
    shiftId,
    workerId,
  });

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="neutral"
      title="Orientation required to work at this facility"
      description="Please complete all orientation activities requested by the facility. You will be able to book shifts after orientation completion."
      illustrationType="unlock"
      footer={
        <LoadingButton
          fullWidth
          variant="contained"
          size="medium"
          isLoading={isLoading}
          onClick={onClick}
        >
          {buttonText}
        </LoadingButton>
      }
    />
  );
}
